import {
  safeClone,
  ViewStream,
  ChannelPayloadFilter,
  ChannelFetchUtil,
  SpyneAppProperties,
} from "spyne";
import { PageTraits } from "traits/page-traits.js";
import { PageDocsItem } from "components/pages/page-docs-item";
import { sendPostMsg } from "@franciscobatista/spyne-plugin-post-msg-tmp";
import { UICreateAppBtn } from "components/ui/ui-create-app-btn";
import { PageConfiguratorHeading } from 'components/pages/page-configurator-heading';

let _dynamoDbApiURL;

export class PageConfigurator extends ViewStream {
  static #accessToken = null;

  constructor(props = {}) {
    props.traits = PageTraits;
    props.data = safeClone(props.pageData);
    props.id = "l1-Configurator";
    props.class = "app-page";
    props.configData = props.configData || {};
    props.authData = props.authData || { isAuthenticated: false };
    props.data.contentLen = PageTraits.page$GetContentLength(props.data);
    props.template = require("./templates/page-configurator.tmpl.html");
    props.channels = ["CHANNEL_UI", "CHANNEL_AUTH", "CHANNEL_POST_MSG"];
    _dynamoDbApiURL = SpyneAppProperties.getProp("apiDynamoDb");

    super(props);
  }

  addActionListeners() {
    // return nexted array(s)

    const configPlFilter = new ChannelPayloadFilter({
      payload: (pl) => ['iframeConfig', 'iframeResize'].includes(pl?.metadata?.type),
    });

    return [
      ["CHANNEL_UI_CLICK_EVENT", "onLaunchPreviewClick", "#btn-launch-preview"],
      ["CHANNEL_UI_CLICK_EVENT", "onCreateApp", "#btn-create-app"],
      ["CHANNEL_AUTH_WINDOW_REQUEST_EVENT", "onPreviewWindowAuthRequest"],
      ["CHANNEL_APP_ROUTE_PAGE_CHANGE_EVENT", "disposeViewStream"],
      ["CHANNEL_ROUTE_CHANGE_EVENT", "page$ScrollSectionIntoView"],
      [
        "CHANNEL_POST_MSG_MESSAGE_RECEIVED_EVENT",
        "onPostMsgEvent",
        configPlFilter,
      ],
      ["CHANNEL_AUTH_.*EVENT", "onChannelAuth"],
    ];
  }
  onSubscribe(d) {
   //console.log("DATA NEW APP IS ", { d });
  }

  onCreateApp(e) {
   //console.log("CREATE APP CALLED ", this.props.authData);

    return;

    const { authData, configData } = this.props;
    const { isAuthenticated, userProfile } = authData;

    if (isAuthenticated === false) {
      console.warn("USER NOT LOGGED IN", {
        isAuthenticated,
        userProfile,
        authData,
      });
      return;
    }

    const userId = userProfile?.sub;
    const { mainConfig, path } = configData;

    const userURL = "http://127.0.0.1:3010/user";
    const requestType = "createUserApp";

    const config = mainConfig;
    const requestData = { requestType, config, userId };

   //console.log("REQUEST DATA ", { requestData, configData, authData });

    const appGenFetch = new ChannelFetchUtil(
      {
        url: userURL,
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        "content-type": "application/json",
        debug: true,
        body: JSON.stringify(requestData),
      },
      this.onSubscribe.bind(this),
    );
  }

  onPostMsgEvent(e){
    const {type} = e.payload?.metadata;
    if (type === 'iframeConfig'){
      this.onConfigUpdated(e);
    } else if (type === 'iframeResize'){
      this.updateIframeHeight(e);
    }

  }

  onConfigUpdated(e) {
    const { payload } = e;
    const { msg, metadata } = payload;
    const { mainConfig, path } = msg;
    this.props.configData = { mainConfig, path };

   //console.log("CONFIG IS ", { mainConfig, path, msg, metadata, e });
  }

  updateIframeHeight(e){
    const { payload } = e;
    const { msg, metadata } = payload;
    const { height } = msg;
   //console.log("UPDATE IFRAME HEIGHT ",this.props.iframeView,{height, payload, msg, metadata})
    if (typeof height === 'number'){
      this.props.iframeView.props.el.querySelector('iframe').style.height = `${height*1+100}px`;
    }


  }

  get config() {
    return this.props.configData;
  }

  onPreviewWindowAuthRequest(e) {
    const { sender } = e.payload?.metadata;
    const origin = sender;

   //console.log("IS WINDOW REQUEST ", e.payload, e);
    const { windowPreview } = this?.props;

    if (windowPreview) {
      const { userProfile, isAuthenticated } = this?.props?.authData;
      const metadata = { origin, type: "authInfo" };
      const token = PageConfigurator.#accessToken;
      const msg = { userProfile, isAuthenticated, token };

     //console.log("SENDING IS ", { msg, windowPreview, origin });

      sendPostMsg(msg, windowPreview, metadata);
    }
  }

  onChannelAuth(e) {
   //console.log("channel auth is ", e.payload, e);
  }

  setAccessToken(token) {
    PageConfigurator.#accessToken = token;

   //console.log("TOKEN IN CONFIGURATOR ", PageConfigurator.#accessToken);
  }

  broadcastEvents() {
    // Only declare the pair when the element is present — the launch
    // button doesn't exist on every configurator state, and an unmatched
    // selector warns at construction.
    const launchBtn$ = this.props.el$("#btn-launch-preview");
    return launchBtn$.exists ? [["#btn-launch-preview", "click"]] : [];
  }

  addPageDocItems() {
    const addPageItems = (data) => {
    //console.log("CONFIGURATOR PAGE ITEMS ",data);
      const iframeView = new PageDocsItem({ data });
      this.appendView(iframeView, ".page-content");
      this.props.iframeView = iframeView;
      this.props.iframeViewWindow = iframeView.props.el.document;
    };
  //console.log("CONFIGURATOR PAGE ITEMS ALL",this.props.appData.configuratorPageContent);

    this.props.appData.configuratorPageContent.forEach(addPageItems);
  }

  onLaunchPreviewClick(e) {
    //const {isLoggedIn, token} = AuthTraits.auth$GetToken();

    //console.log("LAUNCH PREVIEW ",{isLoggedIn, token});

    function openNewWindow(url, target = "_blank", features = "") {
      const newWindow = window.open(url, target, features);

      // If the popup was blocked by the browser, newWindow will be null
      if (!newWindow) {
        console.error(
          "Failed to open the new window (possibly blocked by a popup blocker).",
        );
        return null;
      }

      // Optional: focus the new window (some browsers may ignore this)
      newWindow.focus();

      return newWindow;
    }

    // Example usage:

    const origin = SpyneAppProperties.getProp("previewSite");

    const popupRef = openNewWindow(
      origin,
      "popupWindow",
      "width=800,height=800",
    );
    this.props.windowPreview = popupRef;
    let num = 0;
    let timeoutNum = 850;

    // sendPostMsg(`Hello from the opener! num:${num}, timeoutNum: ${timeoutNum}`, popupRef);
    const delayer = () => {
      const { userProfile, isAuthenticated } = this.prop?.authData;
      const token = PageConfigurator.#accessToken;

      popupRef.postMessage({ userProfile, isAuthenticated, token }, origin);

      //sendPostMsg(`Hello from the opener31! num:${num}, timeoutNum: ${timeoutNum}`, popupRef, {type:'accessToken', token:'abc'});

      if (num < 3) {
        // num++;
        // timeoutNum = 550 * num;
        // window.setTimeout(delayer, timeoutNum);
      }

      num++;
    };
    // Later, you can post messages to the new window:
    if (popupRef) {
      //  window.setTimeout(delayer, timeoutNum);
      //popupRef.postMessage("Hello from the opener!", "*");
    }
  }

  addTestPreviewBtn() {
    const props = {
      id: "btn-launch-preview",
      class: "btn",
      tagName: "button",
      data: "LAUNCH PREVIEW",
    };

    const propsCreate = {
      id: "btn-create-app",
      class: "btn",
      tagName: "button",
      data: "CREATE APP",
    };

    this.appendView(new ViewStream(props), ".code-sample-header");
    this.appendView(new ViewStream(propsCreate), ".code-sample-header");
  }

  sendIframeHeightRequest(){
    const type = 'iframeConfig';
    const origin = 'parent';
    const metadata = {type, origin};

    sendPostMsg(metadata, this.props.iframeViewWindow, metadata);
  }

  onRendered() {
   //console.log("PAGE AUTH DATA ", this.props);
    this.addChannel("CHANNEL_APP_ROUTE", true);
    this.addChannel("CHANNEL_ROUTE", true);
    this.page$InitPage();
    this.page$checkFor404();
    this.addPageDocItems();

   //console.log("CONFIGURATOR PAGE ITEMS APP DATA ",this.props.appData);


    const capsData = this.props.appData?.capabilitiesPageContent[0];

    this.prependView(new PageConfiguratorHeading({
      data: capsData
    }), ".app-gen-block-2");


    this.appendView(new UICreateAppBtn(), ".capabilities-heading .heading-item-text");
    this.sendIframeHeightRequest();

    this.page$ScrollToTopOnLoad();

    const addReveal = ()=>{

      if (this?.props){
        this.props.el$("#page-body").addClass('reveal');
      }
    }

    window.setTimeout(addReveal, 770);

    // this.addTestPreviewBtn();
  }
}
